import { API } from '@/config';
import type { PortfolioSummary } from '@/types';
import { api } from './client';

/**
 * The estate at a glance.
 *
 * One call, because the sections of the screen must agree with each other -
 * see server/src/api/admin/dashboard.routes.ts for why that is a rule rather
 * than a convenience.
 */
export const dashboardService = {
  summary(attention: number, signal?: AbortSignal): Promise<PortfolioSummary> {
    return api.get<PortfolioSummary>(
      `${API.endpoints.dashboard}?attention=${String(attention)}`,
      signal ? { signal } : {},
    );
  },
};
